import { Injectable } from "@angular/core";
import { HttpService } from "../../services/http.service";
import { BaseModel } from "./base-model";

@Injectable()
export class AdaptiveCourseModelService extends BaseModel {
	private _adaptiveXMLData: XMLDocument;
	private _arrPoints = [];
	private _strPenmanName = "";
	private _strCourseTopic = "";
	private _strLearningType = "";
	private _strComplianceTypeID = "";
	private _strComplianceTypeName = "";
	private _strModuleVersion = "";
	private _strAccessibilityOption = "";
	private _arrModuleShortname = [];
	private _arrLearningPoints = [];
	private _hasAdaptiveXML:boolean = false;
	constructor(private httpService: HttpService) {
		super();
	}

	public initialize(url) {
		if(url) {
		this.httpService.getXmlData(url).then((res: any) => {
			this._hasAdaptiveXML = true;
			this._adaptiveXMLData = res;
			this.parseAdaptiveXML();
			this._notifier.next("data");
		});
	}
	}
	private parseAdaptiveXML() {
		this.parseScoringData();
		this.parseReportingData();
		this.parseLearningPointsData();
	}
	private parseScoringData() {
		let scoreLen;
		scoreLen = this._adaptiveXMLData.getElementsByTagName("score").length;
		for (let i = 0; i < scoreLen; i++) {
			let obj: any = [];
			obj.attempt = (this._adaptiveXMLData.getElementsByTagName("score")[i].getAttribute("attempt")) ? this._adaptiveXMLData.getElementsByTagName("score")[i].getAttribute("attempt").trim() : "0";
			obj.page_id = [];
			
			let arrTotalPages = (this._adaptiveXMLData.getElementsByTagName("score")[i].getAttribute("pages")) ? this._adaptiveXMLData.getElementsByTagName("score")[i].getAttribute("pages").split(",") : [];
			
			for (let j = 0; j < arrTotalPages.length; j++) {
				obj.page_id.push(arrTotalPages[j].trim());
			}
			obj.points = (this._adaptiveXMLData.getElementsByTagName("score")[i].textContent) ? this._adaptiveXMLData.getElementsByTagName("score")[i].textContent.trim() : "0";
			this._arrPoints.push(obj);
		}
	}
	private parseReportingData() {
		this._strPenmanName = this._adaptiveXMLData
			.getElementsByTagName("penmanName")[0]
			.textContent.trim();
		this._strCourseTopic = this._adaptiveXMLData
			.getElementsByTagName("courseTopic")[0]
			.textContent.trim();
		this._strLearningType = this._adaptiveXMLData
			.getElementsByTagName("learningType")[0]
			.textContent.trim();
		this._strComplianceTypeID = this._adaptiveXMLData
			.getElementsByTagName("complianceTypeID")[0]
			.textContent.trim();
		this._strComplianceTypeName = this._adaptiveXMLData
			.getElementsByTagName("complianceTypeName")[0]
			.textContent.trim();
		this._strModuleVersion = this._adaptiveXMLData
			.getElementsByTagName("moduleVersion")[0]
			.textContent.trim();
		this._strAccessibilityOption = this._adaptiveXMLData
			.getElementsByTagName("accessabilityOption")[0]
			.textContent.trim();
		let modShortNameLen =
			this._adaptiveXMLData.getElementsByTagName("module").length;
		for (let i = 0; i < modShortNameLen; i++) {
			let obj: any = {};
			obj.module_id = this._adaptiveXMLData
				.getElementsByTagName("module")
				[i].getAttribute("module_id");
			if(this._adaptiveXMLData.getElementsByTagName("module")[i].getElementsByTagName("name").length > 0){
				obj.module_short_name = this._adaptiveXMLData.getElementsByTagName("module")[i].getElementsByTagName("name")[0].textContent.trim();
			} else {
				obj.module_short_name = this._adaptiveXMLData.getElementsByTagName("module")[i].textContent.trim();
			}
			let cId = this._adaptiveXMLData.getElementsByTagName("module")[i].getElementsByTagName("complianceTypeID")[0];
			let cName = this._adaptiveXMLData.getElementsByTagName("module")[i].getElementsByTagName("complianceTypeName")[0];
			obj.complianceTypeID = (cId)?cId.textContent.trim():"";
			obj.complianceTypeName = (cName)?cName.textContent.trim():"";
			this._arrModuleShortname.push(obj);
		}
	}
	private parseLearningPointsData() {
		let lpLen =
			this._adaptiveXMLData.getElementsByTagName("learningPoint").length;
		for (let i = 0; i < lpLen; i++) {
			let obj: any = [];
			obj.page_id = [];
			let arrTotalPages = this._adaptiveXMLData
				.getElementsByTagName("learningPoint")
				[i].getAttribute("page_id")
				.split(",");
			for (let j = 0; j < arrTotalPages.length; j++) {
				obj.page_id.push(arrTotalPages[j].trim());
			}
			obj.learningPoint = this._adaptiveXMLData
				.getElementsByTagName("learningPoint")
				[i].textContent.trim();
			this._arrLearningPoints.push(obj);
		}
	}
	public get arrPoints() {
		return this._arrPoints;
	}
	public get strPenmanName() {
		return this._strPenmanName;
	}
	public get strCourseTopic() {
		return this._strCourseTopic;
	}
	public get strLearningType() {
		return this._strLearningType;
	}
	public get strComplianceTypeID() {
		return this._strComplianceTypeID;
	}
	public get strComplianceTypeName() {
		return this._strComplianceTypeName;
	}
	public get strModuleVersion() {
		return this._strModuleVersion;
	}
	public get strAccessibilityOption() {
		return this._strAccessibilityOption;
	}
	public get arrModuleShortname() {
		return this._arrModuleShortname;
	}
	public get arrLearningPoints() {
		return this._arrLearningPoints;
	}
	public get adaptiveXMLData() {
		return this._adaptiveXMLData;
	}
	public get hasAdaptiveXML(){
		return this._hasAdaptiveXML;
	}
}
